import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { PhotoCellLocalStoreService } from './photo-cell-local-store.service';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';
import { LSCField } from '../../../../../models/LSCFields';
import { PrependProtocolPipe } from '../../../../../pipes/prepend-protocol.pipe';
import { sendToGoogleAnalytics } from '../../../../../core/utilities';
import { LocationListService } from '../../location-list.service';
import { SplitStringPipe } from '../../../../../pipes/split-string.pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-photo-cell',
    templateUrl: './photo-cell.component.html',
    styleUrls: ['./photo-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PhotoCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, NgClass, MatIcon, MatTooltip, NgxSkeletonLoaderModule, SplitStringPipe, PrependProtocolPipe]
})
export class PhotoCellComponent extends AgCellRendererComponent {

  viewModel$ = this.localStore.viewModel$;
  LSCField = LSCField;
  prependProtocol = new PrependProtocolPipe();
  constructor(protected localStore: PhotoCellLocalStoreService,
              private gridLocalStore: LocationListLocalStoreService,
              private locationList: LocationListService) {
    super(localStore);
  }

  /**
   * Opens an image preview in the left-bottom corner.
   * @param imageUrl Shows the image this URL is directing to.
   */
  openImage(imageUrl: string) {
    this.gridLocalStore.updateImagePreviewURL(this.prependProtocol.transform(imageUrl));
  }

  /**
   * Closes the image preview in the left-bottom corner.
   */
  closeImage() {
    this.gridLocalStore.updateImagePreviewURL(null);
  }

  trackPhotoClick(field: string) {
    sendToGoogleAnalytics('open photo', 'Navigation', ('Open' + field));
  }

  /**
   * Download and show original cover photo in a new tab
   * @param coverPhotoURL
   */
  openOriginalCoverPhotoInNewTab(coverPhotoURL: string) {
    this.locationList.openOriginalCoverPhotoInNewTab(this.prependProtocol.transform(coverPhotoURL));
  }
}

